import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "suhool_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [miniOpen, setMiniOpen] = useState(false);
  const [lastAddedSku, setLastAddedSku] = useState(null);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.sku === product.sku);
      if (found) return prev.map((i) => i.sku === product.sku ? { ...i, qty: i.qty + qty } : i);
      return [...prev, {
        sku: product.sku, slug: product.slug, name_ar: product.name_ar,
        price: product.price, weight_grams: product.weight_grams || 0,
        image: (product.images && product.images.main) || product.image, qty,
      }];
    });
    setLastAddedSku(product.sku);
    setMiniOpen(true);
    toast.success("أُضيف إلى سلتك", { description: product.name_ar });
  }, []);

  const setQty = useCallback((sku, qty) => {
    setItems((prev) => qty <= 0 ? prev.filter((i) => i.sku !== sku)
      : prev.map((i) => i.sku === sku ? { ...i, qty } : i));
  }, []);

  const remove = useCallback((sku) => {
    setItems((prev) => prev.filter((i) => i.sku !== sku));
    toast("أُزيل من سلتك");
  }, []);
  const clear = useCallback(() => setItems([]), []);
  const openMini = useCallback(() => setMiniOpen(true), []);
  const closeMini = useCallback(() => setMiniOpen(false), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const weight = items.reduce((s, i) => s + (i.weight_grams || 0) * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, weight, miniOpen, openMini, closeMini, lastAddedSku }}>
      {children}
    </CartContext.Provider>
  );
}
